<template>
  <div class="share-groupbuy-store scroll-touch" :style="mainStyle" >
    <!-- <img
      src="./images/mask-group.png"
      class="mask-group-background"
    /> -->
    <div class="share-store-groupbuy-main">
      <div class="share-store-groupbuy-main-content">
        <ShareGroupbuyStoreTitle shareTitle="WOWNOW-Local Service" :lang="lang" />
        <div
          class="store-name"
          v-text="tipsLang"
          :class="{ 'store-name-zh': lang && lang === 'zh' }"
        />
        <StoreGroupbuyCard
          @setproduct="setproduct"
          :detail="detail"
          :lang="lang"
          v-if="!isStoreError && isLoading"
        />
        <WxOpenLaunchAppLocalV3
          comId="groupStore-lauch-btn-1"
          ref="WxOpenAppRef"
          :extinfoProps="wxGoAppRouter"
          v-if="!!isWechat && !isStoreError && locationQuery.routePath"
          :appid="wechatAppid"
          @click="wxClick"
          @launch-success="launchSuccess"
          @launch-error="launchError"
        >
          <!-- 跳转app按钮 -->
          <div
              v-if="!isStoreError && locationQuery.routePath"
              @click="setSign"
              class="button-class"
              :class="{ 'noProduct': noProduct }"
            >
              <div class="position-center btn-text" v-text="btnLang" />
            </div>
        </WxOpenLaunchAppLocalV3>
        <div
          v-if="!isWechat && !isStoreError && locationQuery.routePath"
          class="button-class"
          @click="goApp"
          :class="{ 'noProduct': noProduct }"
        >
          <div class="position-center btn-text" v-text="btnLang" />
        </div>
        <StoreGroupbuyError v-if="isStoreError" :errorTxt="emptyStoreLang" />
      </div>
    </div>

    <transition name="slide-fade">
      <div class="masking" v-if="isShowMasking" @click="isShowMasking = false">
        <div class="masking-content">
          <div class="masking-tips-site">
            <div class="tips-row">
              <div class="round display-middle">1</div>
              <div class="display-middle tips-text">{{ maskingLang.one.one }}</div>
              <img class="display-middle blue-menu" :src="logoImgs.blueMenuImageSrc" />
              <div class="display-middle tips-text">{{ maskingLang.one.two }}</div>
            </div>
            <div class="tips-row">
              <div class="round display-middle">2</div>
              <div class="display-middle tips-text">{{ maskingLang.two.one }}</div>
              <div class="display-middle blue-button-site">
                <img class="display-middle blue-button" :src="logoImgs.blueButtonImageSrc">
                <img class="earth" :src="logoImgs.earthImageSrc" />
                <div class="tips-text earth-text">{{ maskingLang.two.two }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import i18nMixin from './mixins/i18n';
import goappMixins from './mixins/goappMixins'
import ShareGroupbuyStoreTitle from './components/share-groupbuy-store-title';
import StoreGroupbuyCard from './components/store-groupbuy-card';

import { getGroupbuyStoreDetail } from '../../apis/gateway-web/store';
import WechatJssdk from '$common/utils/wechat/web-jssdk';
import WxOpenLaunchAppLocalV3 from "$common/components/wechat/wx-open-launch-app-local-v3";

const StoreGroupbuyError = resolve => import('./components/store-groupbuy-error');
export default {
  documentTitle: 'WOWNOW-Local Service',
  components: { ShareGroupbuyStoreTitle, StoreGroupbuyCard, StoreGroupbuyError,WxOpenLaunchAppLocalV3 },
  mixins: [i18nMixin,goappMixins],
  created() {
    WechatJssdk.config()?.then(res => WechatJssdk?.share())?.catch(err => {
      console.log('WechatJssdk err: ', err)
    });
    this.$nextTick(() => this.getGroupbuyStoreDetail());

  },
  data() {
    return {
      noProduct: false,
      detail: window?.ssrConfig?.routerConfig?.storeDetail ?? undefined,
      isStoreError: !(window?.ssrConfig?.routerConfig?.storeDetail),
      isLoading: !!(window?.ssrConfig?.routerConfig?.storeDetail) ?? false,
    };
  },
  computed: {
    mainStyle() {
      return this.$root.clientHeight && `height: ${this.$root.clientHeight}px; background: url(${require('./images/mask-group.png')}) no-repeat;background-size: 100% auto;` || '';
    },
    backgroundImageStyle() {
      return this.$root.clientHeight && `min-height: ${this.$root.clientHeight}px;` || '';
    },

    tipsLang() {
      if (this.lang === 'zh') {
        return '这间门店不错，分享给你~';
      }
      if (this.lang === 'km') {
        return 'ហាងនេះល្អ ចែករំលែកជាមួយអ្នក';
      }
      return 'This store is good, share it with you';
    },
    btnLang() {
      if (this.lang === 'zh') {
        return '打开APP';
      }
      if (this.lang === 'km') {
        return 'បើកកម្មវិធី';
      }
      return 'Open APP';
    },
    emptyStoreLang() {
      if (this.lang === 'zh') {
        return '门店不存在';
      }
      if (this.lang === 'km') {
        return 'អត់មានហាង';
      }
      return 'Store does not exist';
    },

   
  },
  methods: {
    setproduct(list) {
      console.log('list',list)
      list && list.length>0 ? this.noProduct = false: this.noProduct = true
    },
    getGroupbuyStoreDetail() {
      if (this?.locationQuery?.storeNo) {
        getGroupbuyStoreDetail({
          storeNo: this?.locationQuery?.storeNo
        }, {
          success: res => {
            this.detail = res;
            this.isStoreError = false;
          },
          fail: res => {
            this.isStoreError = true;
          }
        }).finally(() => {
          this.isLoading = true;
        })
      } else {
        this.isStoreError = true;
        this.isLoading = true;
      }
    },
  }
};
</script>
<style lang="stylus" scoped>
.share-store-groupbuy-main{
  width: 100%;
  height: 100%;
  position: relative;
}

.share-store-groupbuy-main-content {
  width: 100%;
  height: 100%;
  position: relative;
}

.store-name {
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft Tai Le;
  font-weight: bold;
  color: #fff;
}

.store-name-zh {
  font-size: 24px;
}

.button-class {
  width: 220px;
  height: 44px;
  opacity: 1;
  border: 1px solid #FC2040;
  border-radius: 22px;
  margin: 10px 78px 10px;
  position: relative;
  transition: all 0.1s;
  &.noProduct {
  margin: 65px 78px 10px;

  }
}
.button-class-active {
  background: #FC2040;
  color: #fff;
}

.btn-text {
  font-size: 18px;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color:#FC2040;
}
</style>
<style lang="stylus">
  body,
  html {
    position: relative;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    line-height: 1;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    text-size-adjust: none;
    text-rendering: optimizeLegibility;
    -webkit-text-size-adjust: none;
    -webkit-touch-callout: none;
    -webkit-font-smoothing: antialiased;
    -webkit-backface-visibility: hidden;
    -webkit-user-drag: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    overflow: hidden;
  }
  body {
    //background: linear-gradient(0deg, #FF4000 0%, #FF9600 100%);
  }
  .position-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .position-top {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0%);
  }
  .position-left {
    position: absolute;
    top: 50%;
    transform: translate(0%, -50%);
  }

  .scroll-touch {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .display-middle {
    display: inline-block;
    vertical-align: middle;
  }
  .overflow {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
</style>
<style lang="stylus">
.mask-group-background {
  width: 100%;
  height: 100%
  overflow: hidden;
  padding: 0;
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
}


/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: opacity .5s;
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: opacity .5s;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
.masking {
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  background-color: rgba(46, 45, 45, 0.8);
}

.masking-content {
  width: 100%;
  height: 100%;
  position: relative;
}
.masking-tips-site {
  width: fit-content;
  height: 78px;
  color: #fff;
  font-weight: bold;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index 999
}
.tips-text {
  font-size: 20.5px;
}
.blue-menu {
  margin: 0 5px;
  width: 26px;
}
.blue-button {
  margin: 0 5px;
  width: 160px;
}
.blue-button-site {
  position relative
}
.round {
  width: 18px;
  height: 18px;
  line-height 18px;
  border-radius: 50%;
  background-color #ff6d00
  font-size: 15.5px;
  text-align center
  margin-right 10px;
}
.earth {
  width: 22px;
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
  left: 10px;
}
.earth-text {
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
  left: 38px;
  font-size: 14px;
}
.tips-row {
  margin-bottom: 18px;
}
</style>
